module.exports = __webpack_public_path__ + "img/green.e2ab84e2.jpg";